import { el } from 'redom';

import application from 'application';

import { stringToSVG, findIndexByProperty } from 'utilities';
import { preventPropogation } from 'utilities/dom';

import internalEventCodes from 'event-system/codes/internal';
import { sortHostOnTop } from './utilities';
import Tooltip from '../tooltip';

import meetingAttendeesIconString from 'assets/images/meeting-attendees-icon.svg?raw';

const meetingAttendeesIcon = stringToSVG(meetingAttendeesIconString);

class AttendeesControl {

  constructor(meetingOwner) {

    this.meetingOwner = meetingOwner;

    this.attendeeIds = [];
    this.attendees = [];

    this.boundHandleDisplayAttendeesButtonClick = this.handleDisplayAttendeesButtonClick.bind(this);

    this.attendeesCount = el('span.meeting-attendees-count');
    this.displayAttendeesButton = el('button.display-attendees-button.meeting-room-control', [el('span.display-attendees-button-icon-container', meetingAttendeesIcon.cloneNode(true)), this.attendeesCount]);
    this.displayAttendeesButton.addEventListener('click', this.boundHandleDisplayAttendeesButtonClick);
    this.displayAttendeesButton.addEventListener('dblclick', preventPropogation);

    this.el = new Tooltip(this.displayAttendeesButton, '.display-attendees-button-tooltip', 'Viewers');

  }

  onunmount() {
    this.displayAttendeesButton.removeEventListener('click', this.boundHandleDisplayAttendeesButtonClick);
    this.displayAttendeesButton.removeEventListener('dblclick', preventPropogation);
  }

  handleDisplayAttendeesButtonClick(event) {

    event.stopPropagation();

    const attendees = sortHostOnTop(this.attendees, this.meetingOwner);

    application.eventSystem.internal.emit(internalEventCodes.DISPLAY_MEETING_ATTENDEES_LIST, {
      attendees
    });

  }

  hideAttendeesList() {

    application.eventSystem.internal.emit(internalEventCodes.HIDE_MEETING_ATTENDEES_LIST, {});

  }

  async addAttendee(userId) {

    if (this.attendeeIds.indexOf(userId) !== -1) {
      return;
    }

    this.attendeeIds.push(userId);
    this.attendeesCount.textContent = this.attendeeIds.length;

    const users = await application.usersStore.getUsersByIds([userId]);

    this.attendees.push(users[0]);

  }

  removeAttendee(userId) {

    const userIdIndex = this.attendeeIds.indexOf(userId);

    if (userIdIndex === -1) {
      return;
    }

    this.attendeeIds.splice(userIdIndex, 1);
    this.attendeesCount.textContent = this.attendeeIds.length;

    const attendeeIndex = findIndexByProperty(this.attendees, '_id', userId);

    this.attendees.splice(attendeeIndex, 1);

  }

}

export default AttendeesControl;